import { Component, ElementRef, OnInit, Renderer2, inject } from '@angular/core';
import { NavigationEnd, NavigationError, RouteConfigLoadStart, Router, RouterOutlet } from '@angular/router';
import { I18NService } from '@core';
import { ALAIN_I18N_TOKEN, TitleService, VERSION as VERSION_ALAIN, stepPreloader } from '@delon/theme';
import { environment } from '@env/environment';
import { NzModalService } from 'ng-zorro-antd/modal';
import { VERSION as VERSION_ZORRO } from 'ng-zorro-antd/version';

import { OverlayCloseOnScrollService } from './shared/utils/overlay-close-on-scroll.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet />`,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly titleSrv = inject(TitleService);
  private readonly modalSrv = inject(NzModalService);
  private readonly i18n = inject<I18NService>(ALAIN_I18N_TOKEN);
  private readonly overlayCloseOnScrollService = inject(OverlayCloseOnScrollService);

  private readonly donePreloader = stepPreloader();

  constructor(el: ElementRef, renderer: Renderer2) {
    renderer.setAttribute(el.nativeElement, 'ng-alain-version', VERSION_ALAIN.full);
    renderer.setAttribute(el.nativeElement, 'ng-zorro-version', VERSION_ZORRO.full);
  }

  ngOnInit(): void {
    this.overlayCloseOnScrollService.init();

    let configLoad = false;
    this.router.events.subscribe(ev => {
      if (ev instanceof RouteConfigLoadStart) {
        configLoad = true;
      }
      if (configLoad && ev instanceof NavigationError) {
        this.modalSrv.confirm({
          nzTitle: this.i18n.fanyi('common.reminder'),
          nzContent: environment.production
            ? this.i18n.fanyi('common.app-new-version')
            : this.i18n.fanyi('common.route-load-error', ev.url),
          nzCancelDisabled: false,
          nzOkText: this.i18n.fanyi('common.refresh'),
          nzCancelText: this.i18n.fanyi('common.ignore'),
          nzOnOk: () => location.reload()
        });
      }
      if (ev instanceof NavigationEnd) {
        this.donePreloader();
        this.titleSrv.setTitle();
        this.modalSrv.closeAll();
      }
    });
  }
}
